import {OPEN_MODAL, CLOSE_MODAL} from "../actions/"

const defaultState = {
  modals: []
}

export default function reducer(state = defaultState, action) {

  switch (action.type) {
    case OPEN_MODAL: {
      return {
        ...state,
        modals: state.modals.concat(action.modal)
      }
    }
    case CLOSE_MODAL: {
      return {
        ...state,
        modals: state.modals.filter(item => item.id !== action.modal.id),
      }
    }
  }
  return state
}


// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js